import "./DownloadBar.scss";

import DownloadBar from "./DownloadBar";

export default DownloadBar;
